export default __webpack_public_path__ + "static/media/Puma.6e8fc1ac.jpeg";